<template>
  <UserInfoSkeleton :is-loading="!isUserDataReady">
    <PopupBox :popup-styles="{ top: 10, left: -10 }" placement="bottom-start" @visibility-change="handlePopupVisibilityChange">
      <template v-slot:trigger>
        <a href="#" class="user-profile" @click.prevent>
          <UserProfileIcon />
            <span class="user-id ml-2">id: {{ getCurrentUserId }}</span>
          <PopupToggler :is-open="popupVisible" class="ml-2" />
        </a>
      </template>
      <template>
        <ProfilePopupContent />
      </template>
    </PopupBox>
  </UserInfoSkeleton>
</template>

<script>
import { mapGetters } from 'vuex';
import ProfilePopupContent from '../profile-popup-content';
import UserInfoSkeleton from '../user-info-skeleton';
import { UserProfileIcon } from '@/shared/ui/icons';
import { PopupBox, popupToggle, PopupToggler } from '@/shared/ui/popup';

export default {
  mixins: [ popupToggle ],
  components: { UserProfileIcon, PopupBox, PopupToggler, ProfilePopupContent, UserInfoSkeleton },
  computed: {
    ...mapGetters('currentUserModule', ['getCurrentUserId', 'isUserDataReady']),
  },
};
</script>

<style scoped>
.user-profile {
  display: flex;
  justify-content: center;
  align-items: center;
}

.user-id {
  font-family: inherit;
  font-size: 14px;
  color: #71717A;
}
</style>
